/**
 * Default message templates configuration
 * Used as fallback when server data is not available
 */

const defaultTemplates = {
  // Company information
  companyName: '仙人掌影業有限公司',
  companyEmail: 'cactusstudio8@gmail.com',
  companyAddress: '新北市中和區立德街200巷38號1樓',
  // RENT-56：報價單 / 出貨單 header 顯示用的公司電話
  companyPhone: '(02)8668-8657',
  companyTaxId: '00251656',
  contactPerson: '自由揚 Antony Lin',
  lineService: 'https://line.me/R/ti/p/@929bpbpy',
  portfolioUrl: 'https://foreverwebs.com/portfolio/',
  
  // Company image data (base64)
  companyLogoBase64: '',
  companySignatureBase64: '',
  companyStampBase64: '',
  
  // Bank information
  accountName: '仙人掌影業有限公司',
  bankName: '台灣銀行',
  branchName: '台中分行',
  bankCode: '004',
  branchCode: '0031',
  bankAccount: '0000-000-000000',
  
  // Message templates
  quotationNextAction: '確認無誤後請簽名回傳給Line@客服小幫手，若回傳簽名不方便請口頭告知小幫手報價單內容正確，我們就會啟動專案',
  invoicePaymentInstruction: '請於付款期限前完成款項支付，付款完成後請聯繫Line客服以便我們確認款項。如有任何疑問，歡迎隨時聯絡我們。',
  
  // Status display names
  statusPending: '待付款',
  statusPartial: '部分付款',
  statusPaid: '已付款',
  statusOverdue: '已逾期',
  
  // Signature labels
  companySignatureLabel: '仙人掌影業',
  customerSignatureLabel: '客戶簽名',
  
  // Section titles
  remarksSectionTitle: '備註/補充',
  nextActionSectionTitle: '下一步行動',
  paymentInfoSectionTitle: '付款資訊',
  paymentInstructionTitle: '付款說明',
  
  // Last updated
  updatedAt: new Date().toISOString()
};

export default defaultTemplates;
